import {debounce} from "lodash/function";
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export const debouncedScrollTriggerRefresh = debounce(()=>ScrollTrigger.refresh(false),500);
